import { render, staticRenderFns } from "./DataSets.vue?vue&type=template&id=5f53921c&scoped=true"
import script from "./DataSets.vue?vue&type=script&lang=js"
export * from "./DataSets.vue?vue&type=script&lang=js"
import style0 from "./DataSets.vue?vue&type=style&index=0&id=5f53921c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53921c",
  null
  
)

export default component.exports